define(function (require) {

    window.lpTag = window.lpTag || {};

    var _ = require('underscore');
    var ViewController = require('web-agent-framework/ViewController');
    var TableViewController = require('web-agent-framework/TableViewController');

    var DropdownViewController = ViewController.extend({
        ControllerName: "DropdownViewController",

        LPViewMap: {
            dropdownMenuButton: ".lpview_dropdown_menu_button",
            dropdownMenu: ".lpview_dropdown_menu",
            dropdownMenuTable: ".lpview_dropdown_menu_table"
        },

        LPClassesMap: {
            dropdownButtonDisabled: "disable",
            menuItemDisabled: "disabled"
        },

        initialize: function (constructorData) {
            this.callbacksContext = constructorData.context;
            this.menuItemsTable = new TableViewController({
                rowTemplateFile: "LP_dropdown_actions_menu_row.html",
                modelData: constructorData.modelData,
                dataBinder: this.dataBinder,
                dataRenderer: this.dataRenderer,
                focusedView: this.getFirstElement(this.LPViewMap.dropdownMenuButton),
                supportKeysNavigation: true,
                context: this
            });
            if (!constructorData.modelData) {
                this.disableDropdownButton();
            }
            this.addViewController({viewController: this.menuItemsTable, target: this.LPViewMap.dropdownMenuTable});
            this.dropdownMenu = this.getFirstElement(this.LPViewMap.dropdownMenu);
            this.lpHide(this.dropdownMenu);
            this.buttonEnable = true;
        },

        events: function () {
            this.bindViewEvent({selector : this.LPViewMap.dropdownMenuButton, DOMEvent : "click", callback : this.toggleDropdownMenu});
            this.bindViewEvent({selector : this.LPViewMap.dropdownMenuButton, DOMEvent : "blur", callback : this.hideDropdown, ignoreChildBlur : true});
        },

        render: function () {
        }
    });

    DropdownViewController.prototype.dataBinder = {
        rowClicked: function (data) {
            if (data.rowData.disabled) {
                return false;
            }
            if (data.rowData && data.rowData.callback) {
                data.rowData.callback.call(this.callbacksContext, data);
            }
            this.hideDropdown();
        },
        operationCanceled: function (data) {
            this.hideDropdown();
        }
    };

    DropdownViewController.prototype.dataRenderer = {
        numberOfSections: function (data) {
            return 1;
        },
        numberOfRowsInSection: function (data, sectionIndex) {
            return data.length;
        },
        dataForSection: function (data, sectionIndex) {
            return;
        },
        dataForRowInSection: function (data, rowIndex, sectionIndex) {
            var rowData = data[rowIndex];
            var value = {
                actionNameTitle: this.translate(rowData.actionName),
                actionName: rowData.actionName,
                disabledClassName: rowData.disabled ? this.LPClassesMap.menuItemDisabled : ""
            };
            return value;
        }
    };

    DropdownViewController.prototype.toggleDropdownMenu = function () {
        if (this.dropdownMenuVisible) {
            this.hideDropdown();
        } else {
            this.showDropdown();
        }
    };

    DropdownViewController.prototype.showDropdown = function () {
        if (this.dropdownMenu) {
            this.lpShow(this.dropdownMenu);
            this.dropdownMenuVisible = true;
        }
    };

    DropdownViewController.prototype.hideDropdown = function () {
        if (this.dropdownMenu) {
            this.lpHide(this.dropdownMenu);
            this.dropdownMenuVisible = false;
        }
    };

    DropdownViewController.prototype.disableDropdownButton = function () {
        if (this.buttonEnable) {
            this.unbindViewEvent({selector : this.LPViewMap.dropdownMenuButton, DOMEvent : 'click', callback : this.toggleDropdownMenu});
            this.addClass(this.LPViewMap.dropdownMenuButton, this.LPClassesMap.dropdownButtonDisabled);
            this.buttonEnable = false;
            this.updateTooltipDropdownMenu(this.translate("connectionProblemDropdownMenuTooltip"));
            this.hideDropdown();
        }
    };

    DropdownViewController.prototype.enableDropdownButton = function () {
        if (!this.buttonEnable) {
            this.unbindViewEvent({selector : this.LPViewMap.dropdownMenuButton, DOMEvent : 'click', callback : this.toggleDropdownMenu}); // make sure no bind for this callback
            this.bindViewEvent({selector : this.LPViewMap.dropdownMenuButton, DOMEvent : 'click', callback : this.toggleDropdownMenu});
            this.removeClass(this.LPViewMap.dropdownMenuButton, this.LPClassesMap.dropdownButtonDisabled);
            this.buttonEnable = true;
            this.updateTooltipDropdownMenu("");
        }
    };

    DropdownViewController.prototype.updateTooltipDropdownMenu = function (text) {
        var dropdown = this.getFirstElement(this.LPViewMap.dropdownMenuButton);
        if (dropdown) {
            if (text) {
                dropdown.title = text;
                //Create and set a new attribute for alignment, because the tooltip spills out of the screen
                var att = document.createAttribute("tooltip-align");
                att.value = "left";
                dropdown.setAttributeNode(att);
            } else {
                dropdown.removeAttribute("title");
                dropdown.removeAttribute("tooltip-text");
                dropdown.removeAttribute("tooltip-align");

            }
        }
    };

    DropdownViewController.prototype.updateDropdownData = function (data, hardDisable) { //hard disable due to connectivity issues
        if (data && data.constructor === Array) {
            this.menuItemsTable.updateModelData(data);
            this.updateDropdownButtonState(hardDisable);
        }
    };

    DropdownViewController.prototype.toggleDropdownItem = function (actionName, enabled) {
        var data = this.menuItemsTable.modelData,
            itemData = _.find(data, {actionName: actionName});
        if (itemData) {
            itemData.disabled = !enabled;
            this.updateDropdownItemData(itemData);
        }
    };

    DropdownViewController.prototype.updateDropdownItemData = function (itemData) {
        var data, itemKey;
        if (itemData) {
            data = this.menuItemsTable.modelData;
            itemKey = _.findKey(data, {actionName: itemData.actionName});
            if (!_.isUndefined(itemKey)) { // itemKey can be 0, check explicitly for undefined
                data[itemKey] = itemData;
                this.menuItemsTable.updateModelData(data);
            }
        }
    };

    DropdownViewController.prototype.updateDropdownButtonState = function (hardDisable) {
        if (this.menuItemsTable.modelData.length > 0 && !hardDisable) {
            this.enableDropdownButton();
        } else {
            this.disableDropdownButton();
        }
    };

    return DropdownViewController;

});
